import { t } from "i18next";
import * as yup from "yup";

export const faqItemSchema = yup.object({
  question: yup
    .string()
    .trim()
    .max(200, t("Question cannot be longer than 200 symbols"))
    .required(t("Question is required")),
  answer: yup
    .string()
    .trim()
    .max(20000, t("Answer is too long"))
    .required(t("Answer is required")),
  isEnabled: yup.boolean().required()
});
